import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import AlertProps from './types';

import {
  StyledModalOverlay, StyledModal, StyledModalContent, StyledTypeAlert, StyledTextAlert,
} from './styled/Alert.styled';

import Button from '../Button';
import ActionsGroup from '../ActionsGroup';

import { Error, Warning, Success } from '../../icons';
import registerNamespace from './locales';

import useOnPressEnter from '../../hooks/useOnPressEnter';

const alertDefaultPropCloseAlert = () => {};
const alertDefaultPropConfirmFunction = () => {};
const alertDefaultPropOkFunction = () => {};

const namespace = registerNamespace('src/juristec-ui/core/Alert/Alert.tsx');

/**
 * Alert
*/
const Alert = ({
  openAlert = false,
  type = 'success',
  children = <></>,
  closeAlert = alertDefaultPropCloseAlert,
  text = '',
  okFunction = alertDefaultPropOkFunction,
  withoutConfirm = false,
  withFunction = false,
  confirmFunction = alertDefaultPropConfirmFunction,
  noPadding = false,
}: AlertProps) => {
  const { t } = useTranslation(namespace);
  const verifyType = () => {
    if (type === 'error') {
      return <Error />;
    }
    if (type === 'warning') {
      return <Warning />;
    }
    return <Success />;
  };

  const internalOkFunction = () => {
    if (okFunction) okFunction();
    closeAlert();
  };

  const internalConfirmFunction = () => {
    confirmFunction();
    closeAlert();
  };

  const cancelFunction = () => {
    closeAlert();
  };

  useOnPressEnter(withoutConfirm, internalOkFunction);

  return (openAlert ? ReactDOM.createPortal(
    <>
      <StyledModalOverlay alert>
        <StyledModal alert aria-modal aria-hidden tabIndex={-1} role="dialog" className="styledModal">
          {type && (
            <StyledTypeAlert type={type}>
              <div className="circle" />
              {verifyType()}
            </StyledTypeAlert>
          )}
          {text !== '' && (
            <StyledTextAlert type={type}>{text}</StyledTextAlert>
          )}
          <StyledModalContent noPadding={noPadding}>
            {children}
          </StyledModalContent>
          {
            !withoutConfirm && (
              <ActionsGroup>
                <Button
                  autoFocus
                  style={{ margin: '5px' }}
                  onClick={internalOkFunction}
                  size="large"
                >
                  {t('ok')}
                </Button>
              </ActionsGroup>
            )
          }
          {withFunction && (
            <ActionsGroup>
              <Button
                variant="outlined"
                autoFocus
                style={{ margin: '5px' }}
                onClick={cancelFunction}
                size="large"
              >
                {t('cancel')}
              </Button>
              <Button
                autoFocus
                style={{ margin: '5px' }}
                onClick={internalConfirmFunction}
                size="large"
              >
                {t('confirm')}
              </Button>
            </ActionsGroup>
          )}
        </StyledModal>
      </StyledModalOverlay>
    </>, document.body,
  ) : null);
};

export default Alert;
